
import React from 'react'
import { useSelector } from 'react-redux'
import { AiOutlineLeft, AiOutlineRight } from 'react-icons/ai'
import './Products.css'
// import ShoppingCartHook from '@hooks/ShoppingCart.hook'
import { getStoreServiceCategories } from '@services/api.business.service'
import LoadingSection from '@components/LoadingSection'
import { useQuery } from '@tanstack/react-query'
// import ItemCard from '../../zearch/components/ItemCard'
import SectionTitle from './SectionTitle'
import { DownOutlined } from '@ant-design/icons'
import { Dropdown, Space } from 'antd'

/**
 * NearProducts fetches and displays a list of products that are near the user's location.
 * 
 * @param {Object} props - The properties passed to the component.
 * @param {Function} props.setIsShowRecommended - The function to set the visibility of recommended products (no longer used).
 * @param {Array} props.searchHistory - The user's search history.
 * @returns {JSX.Element} The JSX code for the NearProducts component.
 */
export default function StoreServiceCategories({
    business,
    width,
    isMobile,
    selectedCategory,
    setSelectedCategory
}) {
    // const location = useSelector(state => state.user.location)

    const storeCategoryRef = React.useRef(null)

    const {
        isPending,
        // error,
        data,
    } = useQuery({
        queryKey: ['getStoreServiceCategories', business?._id],
        queryFn: () => getStoreServiceCategories({
            business_id: business?._id,
            // is_recommended: true,
            // is_image: 'true'
        }),
    })

    if (isPending)
        return <LoadingSection text='Loading Store Categories' height='200px' />

    const storeCategories = data?.data || []
    // const storeCategories = TestCategories
    if (storeCategories.length === 0)
        return null

    if (!selectedCategory) {
        setSelectedCategory(storeCategories[0]?.children[0]?._id)
    }

    return (
        <section
            style={{
                maxWidth: '100%'
            }}
            className="w-full flex flex-col relative"
        // className={`w-full relative`}
        >
            <SectionTitle title={'Categories'} />
            {/* <div className='relative'> */}
            <div className="w-full flex gap-5 items-center justify-between" ref={storeCategoryRef}>
                {storeCategories?.map((category, index) => (
                    <Dropdown
                        key={index}
                        overlayStyle={{
                            textAlign: 'left',
                        }}
                        menu={{
                            items: category?.children?.map((child) => ({
                                key: child?._id,
                                label: (
                                    <a
                                        onClick={(e) => {
                                            e.preventDefault()
                                            setSelectedCategory(child?._id)
                                        }}

                                    >
                                        {child?.title}
                                    </a>
                                ),
                            })),
                        }}>
                        <a onClick={e => {
                            e.preventDefault()
                            if (!category?.children?.length) {
                                setSelectedCategory(category?._id)
                            }
                        }}>
                            <Space style={{ cursor: 'pointer' }}>
                                {category?.title}
                                {category?.children?.length > 0 && (
                                    <DownOutlined />
                                )}
                            </Space>
                        </a>
                    </Dropdown>
                ))}
            </div>
            {/* </div> */}
        </section>
    )
}
